import React from 'react';

import StyledButton from '@src/components/wysiwyg_editor/page_content_items/control_panels/StyledButton';
import forwardImg from '@images/wysiwyg_editor/control_panels/forward.svg';
import forwardHoverImg from '@images/wysiwyg_editor/control_panels/forward-hover.svg';

type TProps = {
  onClick: () => void;
};

function Forward(props: TProps): React.ReactElement {
  return (
    <StyledButton
      image={forwardImg as string}
      hoverImage={forwardHoverImg as string}
      onClick={props.onClick}
    >
      Forward
    </StyledButton>
  );
}

export default Forward;
